import React, {Component} from "react";  import config from 'react-global-configuration';
import {Grid} from "react-bootstrap";
import Moment from 'react-moment';
import * as moment from "moment";
import jwt_decode from "jwt-decode";
import axios from "axios";

class Notifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user_notifications:[],
      notification_id:null
    }

  }

  componentDidMount() {
    this.userNotifications();
    //alert(this.props.match.params.id);
    this.setState({
      notification_id: this.props.match.params.id
    })
  }
  userNotifications() {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    if(token!=null) {
      axios.get(config.get('API_URL')+'/masterdata/all_notifications/', {
        params: {
          user_id: decoded._id
        },
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        },
      }).then(response => {
        console.log("notifications");
        console.log(response);
        this.setState({
          user_notifications:response.data
        })
      }).catch(err => {
        console.log(err);
      });
    }
  }
  render() {
    let notificationContainer='';

    let notif_cls = "alert-info-custom";
    if(Array.isArray(this.state.user_notifications) && this.state.user_notifications.length) {
      notificationContainer = this.state.user_notifications.map((val, i) => {
        {
          this.state.notification_id == val.notification_id ? notif_cls = 'alert-with-icon  alert alert-info' :
              notif_cls = 'alert-with-icon  alert alert-info-custom'
        }
        return (
            <React.Fragment key={i + 1}>
              <div role="alert" className="alert-with-icon  alert alert-info-custom">
                <span className="pe-7s-bell bell-notification"></span>
                <span data-notify="message">{val.message}</span>
                {/*<span><a href="">Submot</a></span>*/}
                <div className="noti-time">
                  <span className="pe-7s-clock bell-notification"></span>
                  <span data-notify="message" className="msg-time"><Moment
                      format='MMMM Do YYYY, h:mm:ss a'>{val.created_at}</Moment></span>
                </div>
              </div>
            </React.Fragment>
        );
      });
    } else {
      notificationContainer =
          (
             <div>
               <p>There is no notification. </p>
             </div>
          );
    }
    return (
      <div className="content">
        <Grid fluid>
          <div className="card">
            <div className="header">
              <h4 className="title">Notifications</h4>
            </div>
            <div className="content">
              <div className="row">
                <div className="col-md-12">
                  {notificationContainer}
                </div>
              </div>
              <br />
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

export default Notifications;
